
const StavkaCjenika = function(DS) {
    return DS.defineResource({
        name: 'StavkaCjenika',
        endpoint: '/stavkeCjenika',
    });
};

StavkaCjenika.$inject = ['DS'];


export {StavkaCjenika};



// WEBPACK FOOTER //
// ./app/models/stavkaCjenika.js